import ConfirmCameraCount from './ConfirmCameraCount'

export default ConfirmCameraCount;